import { Alert, Snackbar } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { closeNotification, removeNotification } from "../slices/notificationSlice";

export const Notifications = () => {

    const dispatch = useDispatch();
    const notifications = useSelector(state => state.notification.notifications);

    const handleClose = id => {
        dispatch(closeNotification(id));
        setTimeout(() => dispatch(removeNotification(id), 200));
    }

    return (
        <>
            {notifications.map(({ id, message, type, open }) => {
                return <Snackbar
                    key={id}
                    open={open}
                    autoHideDuration={10000}
                    onClose={() => handleClose(id)}
                    anchorOrigin={{ vertical: "top", horizontal: "left" }}
                >
                    <Alert severity={type} onClose={() => handleClose(id)}>{message}</Alert>
                </Snackbar>
            })}
        </>
    );
}